import { useState } from "react";
import { countries } from "../../global/countriesAndSources";
import { addManyPremiumUsers } from "../../HTTP/admin";
import useCurrentLanguage from "../../Helper/useCurrentLanguage";

export default function AddManyUser() {
    const currentLanguage = useCurrentLanguage();
    const isFrenchLanguage = currentLanguage.startsWith("fr");
    const localUser = JSON.parse(localStorage.getItem("user"));
    if (!localUser.super_admin && localUser.admin_access !== 1) {
        window.location.href = "/";
    }

    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        establishment_name: "",
        email: "",
        country: "fr",
        count: 1
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: name === "count" ? Number(value) : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const payload = {
                establishment_name: formData.establishment_name.trim(),
                email: formData.email.trim(),
                country: formData.country,
                count: Number(formData.count)
            };

            const res = await addManyPremiumUsers(payload);
            if (res) {
                alert("Utilisateurs ajoutés avec succès.");
                window.location.href = "/admin/users";
            } else {
                alert("Une erreur est survenue pendant l'ajout en masse.");
            }
        } catch (err) {
            console.log(err);
            alert("Une erreur est survenue pendant l'ajout en masse.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="max-w-md mx-auto mt-8 p-6 bg-white rounded-lg shadow-md">
            <h2 className="text-2xl font-bold mb-6 text-center">Ajout d'utilisateurs en masse</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label htmlFor="establishment_name" className="block text-gray-700 text-sm font-bold mb-2">
                        Nom de l'établissement
                    </label>
                    <input
                        type="text"
                        id="establishment_name"
                        name="establishment_name"
                        value={formData.establishment_name}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        required
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="email" className="block text-gray-700 text-sm font-bold mb-2">
                        Email administrateur
                    </label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        required
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="country" className="block text-gray-700 text-sm font-bold mb-2">
                        Pays
                    </label>
                    <select
                        id="country"
                        name="country"
                        value={formData.country}
                        onChange={handleChange}
                        className={`w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${isFrenchLanguage ? "notranslate" : ""}`}
                        translate={isFrenchLanguage ? "no" : undefined}
                    >
                        {countries.map((c, i) => (
                            <option value={c.code} key={i} className={isFrenchLanguage ? "notranslate" : ""} translate={isFrenchLanguage ? "no" : undefined}>{c.name}</option>
                        ))}
                    </select>
                </div>
                <div className="mb-6">
                    <label htmlFor="count" className="block text-gray-700 text-sm font-bold mb-2">
                        Nombre d'utilisateurs
                    </label>
                    <input
                        type="number"
                        id="count"
                        name="count"
                        min="1"
                        value={formData.count}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        required
                    />
                </div>
                <div className="flex items-center justify-end gap-2">
                    <button
                        type="button"
                        className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded"
                        onClick={() => { window.location.href = "/admin/users"; }}
                    >
                        Annuler
                    </button>
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded disabled:opacity-60"
                        disabled={isLoading}
                    >
                        {isLoading ? "Envoi..." : "Créer les utilisateurs"}
                    </button>
                </div>
            </form>
        </div>
    );
}
